module.exports = __webpack_public_path__ + "img/hamburguesa-de-res.d3a1d74c.jpg";